import { useCallback, useMemo } from "react";
import { CANDIDATE_STATUS, ICandidate } from "../domain/candidate";

export const useGetCandidate = (candidates: ICandidate[]) => {

    const candidateMap = useMemo(() => {
        const map: { [id: string]: ICandidate } = {};
        for (const c of candidates) {
            map[c.id] = c;
        }
        return map;
    }, [candidates])

    return useCallback(
        (id: string): ICandidate => {
            const c = candidateMap[id];
            if (c) {
                return c;
            }
            return {
                id: id,
                label: id,
                created_at: new Date(),
                display_order: 0,
                status: CANDIDATE_STATUS.APPROVED
            }
        }, [candidateMap]);
}